import { render, staticRenderFns } from "./PaapPanel.vue?vue&type=template&id=dfe4ea30"
import script from "./PaapPanel.vue?vue&type=script&lang=js"
export * from "./PaapPanel.vue?vue&type=script&lang=js"
import style0 from "./PaapPanel.vue?vue&type=style&index=0&id=dfe4ea30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports